import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const UserController = () => {
  const navigate = useNavigate();
  useEffect(() => {
    !localStorage.getItem("token") ? navigate("/login") : <></>;

  });

  if (localStorage.getItem("token")) {
    // return console.log("Authentication Failed ");
    return (
      <div>
        <Outlet />
      </div>
    );
  } 
};

export default UserController;
